const ALLOWED_ORIGINS = new Set(['https://maurten.com', 'https://www.maurten.com']);
const FRAME_SELECTOR = '[data-maurten-store-locator-frame]';
const MAX_WIDGET_HEIGHT = 10000;

class MaurtenStoreLocator extends HTMLElement {
  connectedCallback() {
    this.frame = this.querySelector(FRAME_SELECTOR);

    if (!this.frame) return;

    window.addEventListener('message', this.handleMessage);
  }

  disconnectedCallback() {
    window.removeEventListener('message', this.handleMessage);
  }

  handleMessage = (event) => {
    if (!this.frame || event.source !== this.frame.contentWindow) return;
    if (!ALLOWED_ORIGINS.has(event.origin)) return;
    if (!event.data || event.data.type !== 'maurten-widget-resize') return;

    const height = Number(event.data.height);

    if (!Number.isFinite(height) || height <= 0 || height > MAX_WIDGET_HEIGHT) return;

    this.frame.style.height = `${Math.ceil(height)}px`;
  };
}

if (!customElements.get('maurten-store-locator')) {
  customElements.define('maurten-store-locator', MaurtenStoreLocator);
}
